import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getEdgeEventsAlerts, getEdgeEventsRules, getEdgeEventsSites, patchEdgeEventsAlert, postEdgeEventsAlert, removeEdgeEventsAlert } from './data';
import { errorReceiveEdgeEventsAlerts, errorReceiveEdgeEventsRules, errorReceiveEdgeEventsSites, errorReceiveModifyEdgeEventsAlert, errorReceiveRemoveEdgeEventsAlert, errorReceiveSetEdgeEventsAlert, failedReceiveEdgeEventsAlerts, failedReceiveEdgeEventsRules, failedReceiveEdgeEventsSites, failedReceiveModifyEdgeEventsAlert, failedReceiveRemoveEdgeEventsAlert, failedReceiveSetEdgeEventsAlert, receiveEdgeEventsAlerts, receiveEdgeEventsRules, receiveEdgeEventsSites, receiveModifyEdgeEventsAlert, receiveRemoveEdgeEventsAlert, receiveSetEdgeEventsAlert } from './slice';
export function* requestEdgeEventsAlerts() {
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEdgeEventsAlerts, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveEdgeEventsAlerts());
        }
        else if (data) {
            yield put(receiveEdgeEventsAlerts(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_ALERTS', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeEventsAlerts());
    }
}
export function* requestEdgeEventsRules() {
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEdgeEventsRules, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveEdgeEventsRules());
        }
        else if (data) {
            yield put(receiveEdgeEventsRules(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_RULES', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeEventsRules());
    }
}
export function* requestEdgeEventsSites() {
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEdgeEventsSites, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveEdgeEventsSites());
        }
        else if (data) {
            yield put(receiveEdgeEventsSites(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_SITES', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeEventsSites());
    }
}
export function* requestSetEdgeEventsAlert(action) {
    try {
        const { alertPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postEdgeEventsAlert, organization, alertPayload);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveSetEdgeEventsAlert());
            yield put(appDanger(t('ERROR_REQUEST_SUBSCRIBE_ALERT', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveSetEdgeEventsAlert(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_SUBSCRIBE_ALERT', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_SUBSCRIBE_ALERT', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveSetEdgeEventsAlert());
        yield put(appDanger(e.message));
    }
}
export function* requestModifyEdgeEventsAlert(action) {
    try {
        const { alertPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchEdgeEventsAlert, organization, alertPayload);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveModifyEdgeEventsAlert());
            yield put(appDanger(t('ERROR_REQUEST_MODIFY_ALERT', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveModifyEdgeEventsAlert(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_ALERT', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_MODIFY_ALERT', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveModifyEdgeEventsAlert());
        yield put(appDanger(e.message));
    }
}
export function* requestRemoveEdgeEventsAlert(action) {
    try {
        const { alertPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeEdgeEventsAlert, organization, alertPayload);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveRemoveEdgeEventsAlert());
            yield put(appDanger(t('ERROR_REQUEST_UNSUBSCRIBE_ALERT', {
                ns: 'Common'
            })));
        }
        else if (data) {
            const { name } = alertPayload;
            yield put(receiveRemoveEdgeEventsAlert(name));
            yield put(appSuccess(t('SUCCESS_REQUEST_UNSUBSCRIBE_ALERT', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_UNSUBSCRIBE_ALERT', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveEdgeEventsAlert());
        yield put(appDanger(e.message));
    }
}
export function* watchRequestEdgeEventsAlerts() {
    yield takeLatest('edgeEvents/requestEdgeEventsAlerts', requestEdgeEventsAlerts);
}
export function* watchRequestEdgeEventsRules() {
    yield takeLatest('edgeEvents/requestEdgeEventsRules', requestEdgeEventsRules);
}
export function* watchRequestEdgeEventsSites() {
    yield takeLatest('edgeEvents/requestEdgeEventsSites', requestEdgeEventsSites);
}
export function* watchRequestSetEdgeEventsAlert() {
    yield takeLatest('edgeEvents/requestSetEdgeEventsAlert', requestSetEdgeEventsAlert);
}
export function* watchRequestModifyEdgeEventsAlert() {
    yield takeLatest('edgeEvents/requestModifyEdgeEventsAlert', requestModifyEdgeEventsAlert);
}
export function* watchRequestRemoveEdgeEventsAlert() {
    yield takeLatest('edgeEvents/requestRemoveEdgeEventsAlert', requestRemoveEdgeEventsAlert);
}
